import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { shareToChatModalActions } from '../../../../../redux/healthboard/patientPortal/share-to-chat-modal';
import { actions as shareToChatActions } from '../../../../../redux/healthboard/patientPortal/share-to-chat-req';
import {
  selectPatientChannelsForShare,
  selectPatientChannelsForSharePending,
  selectSocialChannelsForShare,
  selectSocialChannelsForSharePending,
  shareToChatModal,
  shareToChatModalDocumentUid,
} from '../../../../../redux/healthboard/patientPortal/selectors';
import {
  loggedUserIdSelector,
  targetUserIdSelector,
} from '../../../../../redux/context/selectors';

const mapStateToProps = state => ({
  openedShareToChatModal: shareToChatModal(state),
  mainUserId: loggedUserIdSelector(state),
  targetUserId: targetUserIdSelector(state),
  pending:
    selectPatientChannelsForSharePending(state) ||
    selectSocialChannelsForSharePending(state),
  allPatientChannels: selectPatientChannelsForShare(state),
  allSocialChannels: selectSocialChannelsForShare(state),
  documentUid: shareToChatModalDocumentUid(state),
});

const mapDispatchToProps = {
  close: shareToChatModalActions.close,
  shareToChat: shareToChatActions.init,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/ShareToChatModal/enhance.js